import React, {useContext, useState} from 'react';
import {Button, CircularProgress, Snackbar} from "@material-ui/core";
import {Form, Formik} from "formik";
import FormInitialValues from "../Checkout/FormModel/formInitialValues";
import ValidationSchema from "../Checkout/FormModel/validationSchema";
import NewAffinityFormModel from "../Checkout/FormModel/formModel";
import {makeStyles} from "@material-ui/core/styles";
import AffinityForm from "./Forms/AffinityForm";
import Axios from 'axios';
import {useAuth0} from "@auth0/auth0-react";
import NewAffinitySuccess from "./NewAffinitySuccess";
import Alert from '@material-ui/lab/Alert';
import MasterContext from "../../../../context/MasterContext";

const steps = ['Informacion de la afinidad'];
const {formId, formField} = NewAffinityFormModel;

const useStyle = makeStyles((theme) => ({
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: "-20px"
    },
    button: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginTop: "24px",
        marginBottom: "16px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    formTitle: {
        fontFamily: "EncodeSansBold",
        fontSize: "20px",
        color: "#bb0d66",
    }
}))

function CheckoutNewAffinity(props) {
    const classes = useStyle()
    const {togleReload} = useContext(MasterContext)
    const {getIdTokenClaims} = useAuth0();
    const [activeStep, setActiveStep] = useState(0);
    const currentValidationSchema = ValidationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    let initialValues = FormInitialValues;
    const isEdit = !!props.editInfo

    let editInitialValues;
    if (isEdit) {
        editInitialValues = {
            "id": props.editInfo['id'],
            "company_name": props.editInfo['Afinidad'],
            "business_name": props.editInfo['razonSocial'],
            "managerAffinity_mail": props.editInfo['mailResponsable'],
            "managerAffinity_name": props.editInfo['NombreResponsable'],
            "managerAffinity_lastName": props.editInfo['ApellidoResponsable'],
            "managerAffinity_phone": props.editInfo['telefonoResponsable'],
            "company_logo": props.editInfo['logo'],
            "intermediary_code": props.editInfo['CIntermediario'],
            "organizer_code": props.editInfo['COrganizacion'],
            "assigned_advisers": props.editInfo['AsesoresIDAuth'],
            "activated_products": props.editInfo['Productos'],
            "extra_discount": props.editInfo['descuentoExtra'],
            "model_discount": props.editInfo['descuentoModelo'],
            "adviser_phone": props.editInfo['TelefonoAsesorWapp'],
            "giftcard_amount": props.editInfo['gift_card'],
            "commercial_condition": props.editInfo['commercial_condition'] ? "SI" : "NO",
            "commercial_description": props.editInfo['commercial_description'] ? props.editInfo['commercial_description'] : "",
            "business_unit": props.editInfo['unidad_de_negocio'] ? props.editInfo['unidad_de_negocio'] : "",
            "is_saved": true,
            "statistic_group": props.editInfo['statistic_group'] || "",
        }
        initialValues = editInitialValues
    }

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlertMessage(null);
    };

    async function _submitForm(values, actions) {
        const claims = await getIdTokenClaims();
        const id_token = claims.__raw;

        let activated_products = [0, 0, 0, 0, 0, 0];
        values.activated_products.map((product) => {
            switch (product) {
                case "0":
                    activated_products[0] = 1;
                    break;
                case "1":
                    activated_products[1] = 1;
                    break;
                case "2":
                    activated_products[2] = 1;
                    break;
                case "3":
                    activated_products[3] = 1;
                    break;
                case "4":
                    activated_products[4] = 1;
                    break;
                case "5":
                    activated_products[5] = 1;
                    break;
            }
        })

        values.activated_products = activated_products;

        // console.log("FINAL VAL", values)

        let url = process.env.REACT_APP_BACK_SERVER + '/cargarNuevaAfinidad'

        let formData = new FormData();
        formData.append("file", values['company_logo']);

        setLoading(true)

        if (values['commercial_condition'] !== "SI") {
            values['giftcard_amount'] = 0
            values['commercial_description'] = ""
        }

        if (values['commercial_description'] === "") {
            values['commercial_condition'] = null
        }

        const jsonData = {
            ...values,
            "commercial_condition": values['commercial_condition'] === "SI",
            "id_UN": values['business_unit'],
            "gift_card": parseInt(values['giftcard_amount']),
        }

        Axios.post(url, jsonData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${id_token}`,
                }
            }).then((result) => {
            if (result.status === 200) {
                setLoading(false)
                togleReload()
            }

        }).catch((error) =>
            console.log(error));

        actions.setSubmitting(false);
        setActiveStep(activeStep + 1);
    }

    function _handleSubmit(values, actions) {
        if (isLastStep) {

            _submitForm(values, actions);

        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }


    return (
        <React.Fragment>
            <div style={{padding: "8px 16px 8px 16px", display: "flex", flexDirection: "column"}}>
                <h2 className={classes.formTitle} style={{
                    alignSelf: "center", marginBottom: "8px",
                    fontFamily: 'Poppins', fontWeight: '500'
                }}>{isEdit ? "Editar afinidad" : "Agregar nueva afinidad"}</h2>
                <React.Fragment>
                    {activeStep === steps.length ? (
                        <NewAffinitySuccess loading={loading} edit={isEdit}/>
                    ) : (
                        <Formik
                            initialValues={initialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting, values}) => (
                                <Form id={formId}>
                                    <AffinityForm formField={formField} 
                                                  values={values}
                                                  handleOpenAlert={handleOpenAlert} 
                                                  isEdit={isEdit}/>
                                                  
                                    <div className={classes.buttons}>
                                        {activeStep !== 0 && (
                                            <Button onClick={_handleBack} className={classes.button}>
                                                Atras
                                            </Button>
                                        )}
                                        <div className={classes.wrapper}>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                className={classes.button}

                                            >
                                                {isLastStep ? 'Enviar formulario' : 'Siguiente'}

                                            </Button>
                                            {isSubmitting && (
                                                <CircularProgress
                                                    size={24}
                                                    className={classes.buttonProgress}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                </React.Fragment>
            </div>
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}

export default CheckoutNewAffinity;